import ROUTES from "../../../data/constants/routes";
import { useParams, useLocation } from "react-router-dom";

import TempoRouterLink from "../../../components/tempo-router-link/TempoRouterLink";

import ResetPasswordForm from "../../../features/auth/ResetPasswordForm";
import { Typography } from "@uhc-tempo/components";
const { H1, Link, Paragraph } = Typography;

export default function ResetPassword(props) {
  const { resetToken } = useParams();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const email = urlParams.get("email") || "";

  return (
    <section className="fluid-container page-main__fill ua-bg-supporting-one-opacity-ten ua-padding-jumbo-vertical">
      <div className="ua-grid ua-grid-gap-2-sm ua-grid-gap-3-lg ua-grid-cols-12">
        <div className="auth-content ua-col-span-3-8-lg ua-col-span-2-10-md ua-col-span-1-12-sm">
          <H1 className="ua-text-center" headingStyle={2}>
            {ROUTES.resetPassword.title}
          </H1>
          <div className="auth-content__inner tds-padding-xxlg-top">
            <ResetPasswordForm resetToken={resetToken} email={email} />
            <footer className="ua-text-center">
              <Paragraph>
                <TempoRouterLink
                  className="tds-margin-xlg-horizontal"
                  component={Link}
                  to={ROUTES.login.path}
                >
                  Back to login page
                </TempoRouterLink>
              </Paragraph>
            </footer>
          </div>
        </div>
      </div>
    </section>
  );
}
